import {
    AccountIcon,
    BillingIcon,
    Document,
    Folder,
    HomeLineBig,
    KeyIcon,
    PlansIcon,
    ReceiptIcon,
    Setting,
    Wallet,
    WalletWhite,
} from 'src/ui-components/Iconpack';
import {ReactComponent as HardDriveIcon} from 'src/assets/icons/hard-drive.svg';
import {ReactComponent as ServerIcon} from 'src/assets/icons/server-05.svg';
import {ReactComponent as UsersIcon} from 'src/assets/icons/users-01.svg';
import {ReactComponent as SecurityIcon} from 'src/assets/icons/security-svgrepo-com.svg';
import {ReactComponent as UsersCheckIcon} from 'src/assets/icons/users-check.svg';
import React from 'react';
import {WrapIcon} from './util';
import {FeatureFlags} from '../../utils/features';

export interface NavItemLinkProps {
    title: string;
    path: string;
    icon: React.FC;
    display: boolean;
    mobileAvailable: boolean;
    desktopAvailable: boolean;
    target?: string;
    nestedItems?: NavItemLinkProps[];
    featureFlag?: FeatureFlags;
}

export const NavigationItems: NavItemLinkProps[] = [
    {
        title: 'Home',
        path: '/',
        icon: HomeLineBig,
        display: true,
        mobileAvailable: true,
        desktopAvailable: true,
    },
    {
        title: 'Media Library',
        path: '/media-library',
        icon: Folder,
        display: true,
        mobileAvailable: true,
        desktopAvailable: true,
    },
    {
        title: 'Settings',
        path: '/settings',
        icon: Setting,
        display: true,
        mobileAvailable: false,
        desktopAvailable: true,
    },
    {
        title: 'Wallet',
        path: '/wallet',
        icon: WalletWhite,
        display: true,
        mobileAvailable: false,
        desktopAvailable: true,
    },
    {
        title: 'Settings',
        path: '/settings',
        icon: Setting,
        display: true,
        mobileAvailable: true,
        desktopAvailable: false,
        nestedItems: [
            {
                title: 'Account',
                path: '/dashboard/settings/profile',
                icon: AccountIcon,
                display: true,
                mobileAvailable: true,
                desktopAvailable: true,
            },
            {
                title: 'Plans',
                path: '/dashboard/settings/plans',
                icon: PlansIcon,
                display: true,
                mobileAvailable: true,
                desktopAvailable: true,
            },
            {
                title: 'Billing Information',
                path: '/dashboard/settings/billing',
                icon: BillingIcon,
                display: true,
                mobileAvailable: true,
                desktopAvailable: true,
            },
            {
                title: 'Invoices',
                path: '/dashboard/settings/invoices',
                icon: ReceiptIcon,
                display: true,
                mobileAvailable: true,
                desktopAvailable: true,
            },
            {
                title: 'Wallet',
                path: '/dashboard/settings/wallet',
                icon: Wallet,
                display: true,
                mobileAvailable: true,
                desktopAvailable: true,
            },
            {
                title: 'Api Keys',
                path: '/dashboard/settings/keys',
                icon: KeyIcon,
                display: true,
                mobileAvailable: true,
                desktopAvailable: true,
            },
            {
                title: 'Users',
                path: '/dashboard/settings/users',
                icon: UsersIcon,
                display: true,
                mobileAvailable: false,
                desktopAvailable: true,
            },
            {
                title: 'Invitations',
                path: '/dashboard/settings/invitations',
                icon: UsersCheckIcon,
                display: true,
                mobileAvailable: false,
                desktopAvailable: true,
            },
            {
                title: 'Security',
                path: '/dashboard/settings/security',
                icon: SecurityIcon,
                display: true,
                mobileAvailable: true,
                desktopAvailable: false,
            },
        ],
    },
    {
        title: 'Remote Storage',
        path: '/remote-storage',
        icon: WrapIcon(HardDriveIcon),
        display: true,
        mobileAvailable: false,
        desktopAvailable: true,
    },
    {
        title: 'Custom Domains',
        path: '/domains',
        icon: WrapIcon(ServerIcon),
        display: true,
        mobileAvailable: false,
        desktopAvailable: true,
    },
    {
        title: 'Documentation',
        path: window.location.origin + '/docs/intro',
        icon: Document,
        display: true,
        mobileAvailable: true,
        desktopAvailable: true,
        target: '_blank',
    },
];
